// extracted by mini-css-extract-plugin
module.exports = {"searchGroupNew":"Search_searchGroupNew__2KcJl","searchButtonNew":"Search_searchButtonNew__2Bqq3","clearButtonNew":"Search_clearButtonNew__32Rk9"};